import React, { createContext, useContext, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faInfoCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './style.css';

const NotificationContext = createContext(null);

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return faCheckCircle;
    case 'error':
      return faExclamationCircle;
    case 'warning':
      return faExclamationTriangle;
    case 'info':
    default:
      return faInfoCircle;
  }
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback(({ type = 'info', title, message, onClose }) => {
    setNotification({ type, title: title || getDefaultTitle(type), message, onClose });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification((prev) => {
      if (prev?.onClose && typeof prev.onClose === 'function') {
        prev.onClose();
      }
      return null;
    });
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification, hideNotification }}>
      {children}
      {notification && (
        <div className="global-notification-overlay" onClick={hideNotification}>
          <div
            className={`global-notification-box global-notification-${notification.type}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="global-notification-icon">
              <FontAwesomeIcon icon={getIcon(notification.type)} />
            </div>
            <h4 className="global-notification-title">{notification.title}</h4>
            {notification.message && (
              <div className="global-notification-message">{notification.message}</div>
            )}
            <button className="global-notification-btn" onClick={hideNotification}>
              OK
            </button>
          </div>
        </div>
      )}
    </NotificationContext.Provider>
  );
};

const getDefaultTitle = (type) => {
  switch (type) {
    case 'success':
      return 'Success';
    case 'error':
      return 'Error';
    case 'warning':
      return 'Warning';
    case 'info':
    default:
      return 'Information';
  }
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
